export const WHITE_LIST = [
  { name: 'notFound', children: [] },
  { name: 'login', children: [] },
  { name: 'register', children: [] },
  { name: 'pending-approval', children: [] },
];

export const NOT_FOUND = {
  name: 'notFound',
};

export const REDIRECT_ROUTE_NAME = 'Redirect';

export const DEFAULT_ROUTE_NAME = import.meta.env.PROD
  ? 'DashboardOverview'
  : 'StoreManagement';

export const DEFAULT_ROUTE = {
  title: import.meta.env.PROD ? 'menu.dashboard.overview' : 'menu.store.management',
  name: DEFAULT_ROUTE_NAME,
  fullPath: import.meta.env.PROD ? '/dashboard/overview' : '/store/management',
};
